import React from 'react';

import cx from 'classnames';
import PropTypes from 'prop-types';

import styles from './EditMenu.module.scss';

const link = cx(styles.link, 'd-flex', 'align-items-center', 'px-3', 'py-2');

const EditMenu = ({
  onEdit,
  onPreview,
  onMakeBillable,
  onDelete,
  onAddNote,
  isAddedToUnbilledCharges,
  loadingAction,
}) => {
  const isLoading = loadingAction !== null;

  return (
    <ul
      className={cx(styles.editMenu, 'radius-4', 'bg-white', 'py-2', 'px-0')}
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <li className={cx(styles.listItem, isLoading && styles.disabled)}>
        <button
          type='button'
          disabled={!!loadingAction}
          onClick={onEdit}
          style={{ border: 0, background: 'transparent', width: '100%', textAlign: 'left' }}
        >
          <div className={link}>
            {loadingAction === 'edit' ? (
              <>
                <i className='icon-loading icon-spin me-2' />
                <span>Editing...</span>
              </>
            ) : (
              <>
                <i className='icon-pencil-create me-2' />
                <span>Edit</span>
              </>
            )}
          </div>
        </button>
      </li>
      <li className={cx(styles.listItem, isLoading && styles.disabled)}>
        <button
          type='button'
          disabled={!!loadingAction}
          onClick={onPreview}
          style={{ border: 0, background: 'transparent', width: '100%', textAlign: 'left' }}
        >
          <div className={link}>
            {loadingAction === 'preview' ? (
              <>
                <i className='icon-loading icon-spin me-2' />
                <span>Loading...</span>
              </>
            ) : (
              <>
                <i className='icon-glasses me-2' />
                <span>Preview</span>
              </>
            )}
          </div>
        </button>
      </li>
      {isAddedToUnbilledCharges !== false && (
        <li className={cx(styles.listItem, isLoading && styles.disabled)}>
          <button
            type='button'
            disabled={!!loadingAction}
            onClick={onMakeBillable}
            style={{ border: 0, background: 'transparent', width: '100%', textAlign: 'left' }}
          >
            <div className={link}>
              {loadingAction === 'billable' ? (
                <>
                  <i className='icon-loading icon-spin me-2' />
                  <span>Updating...</span>
                </>
              ) : (
                <>
                  <i className='icon-expense-claim me-2' />
                  <span>Make billable</span>
                </>
              )}
            </div>
          </button>
        </li>
      )}
      <li className={cx(styles.listItem, isLoading && styles.disabled)}>
        <button
          type='button'
          disabled={!!loadingAction}
          onClick={onDelete}
          style={{ border: 0, background: 'transparent', width: '100%', textAlign: 'left' }}
        >
          <div className={link}>
            {loadingAction === 'delete' ? (
              <>
                <i className='icon-loading icon-spin me-2' />
                <span>Removing...</span>
              </>
            ) : (
              <>
                <i className='icon-trash me-2' />
                <span>Remove device</span>
              </>
            )}
          </div>
        </button>
      </li>
      <li className={cx(styles.listItem, isLoading && styles.disabled)}>
        <button
          type='button'
          disabled={!!loadingAction}
          onClick={onAddNote}
          style={{ border: 0, background: 'transparent', width: '100%', textAlign: 'left' }}
        >
          <div className={link}>
            {loadingAction === 'note' ? (
              <>
                <i className='icon-loading icon-spin me-2' />
                <span>Loading...</span>
              </>
            ) : (
              <>
                <i className='icon-file-text me-2' />
                <span>Add note</span>
              </>
            )}
          </div>
        </button>
      </li>
    </ul>
  );
};

EditMenu.propTypes = {
  onDelete: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onPreview: PropTypes.func.isRequired,
  onMakeBillable: PropTypes.func.isRequired,
  onAddNote: PropTypes.func.isRequired,
  isAddedToUnbilledCharges: PropTypes.bool,
  loadingAction: PropTypes.string,
};

EditMenu.defaultProps = {
  isAddedToUnbilledCharges: null,
  loadingAction: null,
};

export default EditMenu;
